import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function QuoteButton({ testId, className = "", small, label = "Get a Quote", to = "/contact", variant = "red" }) {
  const tone = variant === "red"
    ? "bg-[var(--red)] text-white hover:bg-[var(--red-hover)]"
    : variant === "navy" ? "bg-[var(--navy)] text-white hover:bg-[var(--navy-dark)]"
    : "bg-white text-[var(--ink)] hover:bg-slate-100";
  return (
    <Link to={to} data-testid={testId}
      className={`group btn-cut inline-flex items-center gap-2 font-bold uppercase tracking-wider transition-[background-color,transform] duration-300 active:scale-[0.97] ${small ? "text-xs px-6 py-3" : "text-sm px-8 py-4"} ${tone} ${className}`}>
      {label}
      <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}
